<!-- Si vous souhaitez customiser l'app, copiez tous le dossier de l'app ainsi que le block acf associé 
dans le thème enfant, et redéclarez un bloc avec l'app copiée


  Un post est soit "displayable", soit "show"
-->
<script>
import FiltersCpts from "./FiltersCpts.vue";
import RecetteExtrait from "./excerpts/RecetteExtrait.vue";
import dataProperties from "../helpers/dataProperties";
import he from "he";
import { getApiData } from "../helpers/getApi";
import { cleanUrl } from "../helpers/cleanUrl";
export default {
  name: "ShowCpt",
  components: {
    FiltersCpts,
    RecetteExtrait,
  },
  data() {
    return {
      ...dataProperties(),
      dataJson: {},
      dataFiltering: false,
    };
  },
  mounted() {
    this.app = document.querySelector("#app");
    this.dataJson = JSON.parse(this.app.getAttribute("data-json"));
    this.setMaxDisplayablePosts(this.dataJson.max_posts);
    this.setIncrementNumber(this.dataJson.increment_number);
    this.getCpt(this.dataJson.publication_liste_app).then(() => {
      this.activeAllAtStart();
    });
  },
  methods: {
    activeAllAtStart() {
      this.cpts.forEach((cpt) => {
        this.resetCptDisplay(cpt);
      });
      this.recordOriginalCpts();
    },
    async getCpt(cptName) {
      const { website, protocol } = cleanUrl(this.website, this.protocol); // récupère le bon nom de site et le bon protocole
      this.website = website;
      this.protocol = protocol;
      this.cptName = cptName;

      let cptNameForRequest = this.cptName;

      // attention ici en cas d'usage des posts, le nom est différent entre la route et le nom en PHP
      if (this.cptName === "post") {
        cptNameForRequest = "posts";
      }

      if (this.dataJson.choix_de_la_langue_block === undefined) {
        this.dataJson.choix_de_la_langue_block = "fr";
      }

      try {
        if (this.dataJson.activer_le_multilingue) {
          this.cpts = await getApiData(
            `${this.protocol}://${this.website}/wp-json/custom/v1/${cptNameForRequest}?lang=${this.dataJson.choix_de_la_langue_block}`
          );

          this.taxonomiesAndTerms = await getApiData(
            `${this.protocol}://${this.website}/wp-json/wp/v2/taxonomies-and-terms-pl/?lang=${this.dataJson.choix_de_la_langue_block}`
          );
        } else {
          this.cpts = await getApiData(
            `${this.protocol}://${this.website}/wp-json/custom/v1/${cptNameForRequest}`
          );

          //on récupère les taxonomies et les terms
          this.taxonomiesAndTerms = await getApiData(
            `${this.protocol}://${this.website}/wp-json/wp/v2/taxonomies-and-terms/`
          );
        }

        // on charge le contenu des filtres
        this.filters = this.loadFiltersContent(
          this.taxonomiesAndTerms,
          this.cptName
        );
        this.isLoaded = true;
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * Récupère les différents étages de filtres ainsi que leur contenu
     */
    loadFiltersContent(taxonomiesAndTerms, cptName) {
      let filters = [];
      let i = 1;
      for (i = 1; i < 5; i++) {
        let filter = this.dataJson["filtre_etage_" + i];
        filter ? filters.push(filter) : null;
      }
      return filters.map((filter) => {
        if (taxonomiesAndTerms[cptName][filter]) {
          return {
            taxonomy: filter,
            terms: taxonomiesAndTerms[cptName][filter],
            isAllButtonToggled: false,
          };
        }
      });
    },
    displayPostAccordingMaxDisplayable(cpt) {
      // console.log("montre les CPT selon le max possible");
      this.displayablePosts++;
      if (this.displayed < this.maxDisplayable) {
        cpt.display = true;
        this.displayed++;
      } else {
        cpt.display = false;
      }
    },
    handleClick(termName, filter) {
      //console.log("gestion du clic des boutons");
      this.$refs.filtersComponent.resetUserEntry();
      this.lastKeyword = "";
      if (this.originalCpts.length === 0) {
        this.recordOriginalCpts();
      } else {
        if (
          this.originalCpts.length > 0 &&
          this.originalCpts.length !== this.cpts.length
        ) {
          this.cpts = JSON.parse(JSON.stringify(this.originalCpts));
        }
      }
      // console.log("Clic sur un filtre");
      this.filters = this.filters.map((innerFilter) => {
        if (termName === "all") {
          if (innerFilter.taxonomy === filter.taxonomy) {
            return this.toggleAllInFilter(innerFilter);
          } else {
            return innerFilter;
          }
        } else {
          let termsCopy = this.toggleTermClicked(termName, innerFilter);
          let isAllButtonToggled = this.checkIfAnyTermActive(
            termsCopy,
            innerFilter.isAllButtonToggled
          );
          return {
            ...innerFilter, // On copie toutes les propriétés de 'filter'
            terms: termsCopy, // On utilise la copie modifiée des termes
            isAllButtonToggled: isAllButtonToggled, // On met à jour la valeur de 'isAllButtonToggled'
          };
        }
      });
      this.filterCpts(filter);
    },
    toggleTermClicked(termName, innerFilter) {
      let innerFilterTerms = Object.values(innerFilter.terms);
      let termsCopy = innerFilterTerms.map((term) => {
        let termCopy = { ...term }; // Copie de l'objet 'term'
        if (termCopy.name === termName) {
          termCopy.active = !termCopy.active;
        }
        return termCopy;
      });
      return termsCopy;
    },
    checkIfAnyTermActive(termsCopy, isAllButtonToggled) {
      let activeTermFound = termsCopy.some((term) => term.active === true);
      if (isAllButtonToggled && !activeTermFound) {
        return true;
      } else {
        return false;
      }
    },
    incrementmaxDisplayable() {
      this.maxDisplayable = this.maxDisplayable + this.incrementNumber;
      this.displayed = 0;
      this.cpts.forEach((cpt) => {
        if (this.displayed < this.maxDisplayable) {
          if (cpt.show) {
            cpt.display = true;
            this.displayed++;
          }
        }
      });
    },
    toggleAllInFilter(innerFilter) {
      let termsCopy, isAllButtonToggled;
      let innerFilterTerms = Object.values(innerFilter.terms);
      if (innerFilter.isAllButtonToggled === false) {
        termsCopy = innerFilterTerms.map((term) => {
          let termCopy = { ...term }; // Copie de l'objet 'term'
          termCopy.active = false;
          return termCopy;
        });
        isAllButtonToggled = true;
      } else {
        termsCopy = innerFilterTerms.map((term) => {
          let termCopy = { ...term }; // Copie de l'objet 'term'
          termCopy.active = false;
          return termCopy;
        });
        isAllButtonToggled = false;
      }

      return {
        ...innerFilter, // On copie toutes les propriétés de 'filter'
        terms: termsCopy, // On utilise la copie modifiée des termes
        isAllButtonToggled: isAllButtonToggled, // On met à jour la valeur de 'isAllButtonToggled'
      };
    },
    recordOriginalCpts() {
      // console.log("enregistrement des CPTS originaux");
      this.originalCpts = JSON.parse(JSON.stringify(this.cpts));
    },
    setMaxDisplayablePosts(value) {
      this.maxDisplayable = parseInt(value);
    },
    setIncrementNumber(value) {
      this.incrementNumber = parseInt(value);
    },
    userSearchOrDeleteKeyword(keyword) {
      this.lastKeyword = keyword;
      this.displayed = 0;
      this.displayablePosts = 0;
      this.cpts.forEach((cpt) => {
        const title = cpt.title.toLowerCase();

        const checkMatch = (input) =>
          he.decode(input.toLowerCase()).includes(keyword.toLowerCase());

        const checkAcfFields = (acf) => {
          for (const key in acf) {
            if (
              acf[key] &&
              typeof acf[key] === "string" &&
              checkMatch(acf[key])
            ) {
              return true;
            }
          }
          return false;
        };

        const checkTerms = (terms) => {
          for (const key in terms) {
            const termsArray = Array.from(terms[key]);
            for (let i = 0; i < termsArray.length; i++) {
              if (checkMatch(termsArray[i])) {
                return true; // Si un match est trouvé, retourner true directement.
              }
            }
          }
          return false; // Aucun match n'a été trouvé, retourner false.
        };

        const termFound = cpt.terms ? checkTerms(cpt.terms) : false;

        let match = checkMatch(title) || checkAcfFields(cpt.acf) || termFound;
        cpt.display = match && cpt.show;
      });
    },
    filterElementsByKeyword(keyword) {
      this.displayed = 0;
      this.displayablePosts = 0;
      if (this.lastKeyword.length < keyword.length) {
        this.userSearchOrDeleteKeyword(keyword);
      } else {
        //  console.log("lutilisateur efface");
        this.lastKeyword = keyword;
        if (keyword === "") {
          // le champ est vide
          this.syncCptsWithActiveTerms();
        } else {
          // le champ n'est pas vide donc on continue à chercher
          this.userSearchOrDeleteKeyword(keyword);
        }
      }
    },

    syncCptsWithActiveTerms() {
      const { noButtonsAllToggled } = this.getAllButtonsStatus();
      const isAnyTermActive = this.isAnyTermActive();
      if (!isAnyTermActive && noButtonsAllToggled) {
        // this.cpts = JSON.parse(JSON.stringify(this.originalCpts));
        this.cpts.forEach((cpt) => this.resetCptDisplay(cpt));
      } else {
        this.cpts = JSON.parse(JSON.stringify(this.filteredCpts));
      }
    },
    isAnyTermActive() {
      return this.filters.some((filter) => {
        return filter.terms.some((term) => term.active === true);
      });
    },

    /**
     * Cette fonction parcourt les CPTS présents sur la page, récupère l'état du filtre et applique au CPT un état selon l'état du filtre
     */
    filterCpts() {
      this.displayablePosts = 0;
      this.displayed = 0;
      // Parcourir chaque CPT (Custom Post Type)
      this.cpts.forEach((cpt) => {
        // On récupère des infos sur l'état du filtre
        const { taxonomiesActiveInFilters, numberOfInactiveTaxonomy } =
          this.getFilterState(cpt);

        const {
          noButtonsAllToggled,
          allButtonsToggled,
          isAllButtonToggledInFilters,
        } = this.getAllButtonsStatus();

        const useEvery =
          this.dataJson.type_de_filtre_entre_les_taxonomies === "et";

        // En fonction de la satisfaction des filtres, on utilise la méthode "every" ou "some".
        // "every" correspond à "et" : on affiche les taxonomies filtrées dans l'étage un ET dans l'étage 2 : il faut une correspondance entre les taxonomies pour que le CPT s'affiche
        // "some" correspond à "ou" : on affiche les taxonomies filtrées dans l'étage un OU dans l'étage 2 : peu importe les correspondances
        let allActiveFiltersSatisfied = Object.keys(taxonomiesActiveInFilters)[
          useEvery ? "every" : "some"
        ](
          (taxonomy) =>
            isAllButtonToggledInFilters[taxonomy] ||
            taxonomiesActiveInFilters[taxonomy]
        );

        if (
          noButtonsAllToggled &&
          numberOfInactiveTaxonomy === this.filters.length
        ) {
          this.resetCptDisplay(cpt);
        } else {
          this.handleCptDisplayIfFiltered(
            cpt,
            allButtonsToggled,
            allActiveFiltersSatisfied
          );
        }
        this.recordFilteredCpts();
      });
    },
    getAllButtonsStatus() {
      let isAllButtonToggledInFilters = {};
      this.filters.forEach((innerFilter) => {
        const currentTaxonomy = innerFilter.taxonomy;

        // Vérifier si le bouton "tout" est actif pour cette taxonomie
        isAllButtonToggledInFilters[currentTaxonomy] =
          innerFilter.isAllButtonToggled;
      });

      return {
        isAllButtonToggledInFilters,
        noButtonsAllToggled: this.noButtonsAllToggled(
          isAllButtonToggledInFilters
        ),
        allButtonsToggled: this.allButtonsToggled(isAllButtonToggledInFilters),
      };
    },

    noButtonsAllToggled(isAllButtonToggledInFilters) {
      return Object.values(isAllButtonToggledInFilters).every(
        (toggled) => !toggled
      );
    },
    allButtonsToggled(isAllButtonToggledInFilters) {
      return Object.values(isAllButtonToggledInFilters).every(
        (toggled) => toggled
      );
    },
    getFilterState(cpt) {
      let taxonomiesActiveInFilters = {};
      let numberOfInactiveTaxonomy = 0;
      this.filters.forEach((innerFilter) => {
        const currentTaxonomy = innerFilter.taxonomy;

        // Vérifier si le bouton "tout" est actif pour cette taxonomie

        const activeTerms = innerFilter.terms.filter((term) => term.active);

        // Si le CPT contient la taxonomie actuelle
        if (cpt[currentTaxonomy]) {
          const termsIdsInCpt = Array.from(cpt[currentTaxonomy]);
          // Vérifier si l'un des terms actifs est lié à ce CPT
          taxonomiesActiveInFilters[currentTaxonomy] = activeTerms.some(
            (term) => termsIdsInCpt.includes(term.term_id)
          );

          // Dans le cas où aucun term n'est sélectionné, on considère qu'ils le sont tous,
          // pour permettre au CPT de s'afficher si un seul term qui match est sélectionné dans l'autre filtre
          if (this.dataJson.type_de_filtre_entre_les_taxonomies === "et") {
            if (activeTerms.length === 0) {
              taxonomiesActiveInFilters[currentTaxonomy] = true;
            }
          }
        }

        // on comptabilise les taxonomies inactives pour vérifier à la fin si elles le sont toutes et ainsi reseter l'état de l'app
        if (activeTerms.length === 0) {
          numberOfInactiveTaxonomy++;
        }
      });

      return {
        taxonomiesActiveInFilters,
        numberOfInactiveTaxonomy,
      };
    },

    recordFilteredCpts() {
      this.filteredCpts = JSON.parse(JSON.stringify(this.cpts));
    },
    handleCptDisplayIfFiltered(
      cpt,
      allButtonsToggled,
      allActiveFiltersSatisfied
    ) {
      if (allButtonsToggled || allActiveFiltersSatisfied) {
        cpt.show = true;
        cpt.display = true;
        this.displayed++;
        this.displayablePosts++;
        this.maxDisplayable = this.displayed;
      } else {
        cpt.show = false;
      }
    },
    resetCptDisplay(cpt) {
      if (this.displayed < this.dataJson.max_posts) {
        cpt.show = true;
        cpt.display = true;
        this.displayed++;
        this.displayablePosts++;
        this.maxDisplayable = this.displayed;
      } else {
        cpt.show = true;
        cpt.display = false;
        this.displayablePosts++;
      }
    },
  },
};
</script>

<template>
  <FiltersCpts
    v-show="isLoaded"
    @handleClick="handleClick"
    @filterElementsByKeyword="filterElementsByKeyword"
    :filters="filters"
    :type_de_filtre="dataJson.type_de_filtre"
    :dataJson="dataJson"
    ref="filtersComponent"
  />
  <div v-show="isLoaded" :class="extraitPaddingTop">
    <div class="results" v-show="!dataFiltering">
      <RecetteExtrait
        v-show="cpt.show && cpt.display"
        class="cpt-extrait"
        v-for="cpt in cpts"
        :key="cpt.id"
        :cpt="cpt"
        :dataJson="dataJson"
      />
    </div>
    <div class="load-more-container" v-show="!dataFiltering">
      <div
        @click="incrementmaxDisplayable"
        v-if="displayed < displayablePosts"
        class="load-more"
      >
        {{ dataJson.load_more_text }}
      </div>
    </div>
  </div>
  <div v-show="!isLoaded || dataFiltering" class="loader-container">
    <div class="lds-ripple">
      <div class="1" />
      <div class="2" />
    </div>
  </div>
</template>
